var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62796 12.018H8.63284L4.56152 16.4594L0.499023 12.016H3.56503L3.56424 11.999C3.56108 10.4956 3.95755 9.0184 4.71307 7.71861C5.46859 6.41883 6.55599 5.3432 7.86392 4.60188C9.17186 3.86057 10.6533 3.48021 12.1566 3.49974C13.6599 3.51927 15.131 3.93798 16.4192 4.71303L14.9492 6.18303C13.9593 5.68836 12.8593 5.45521 11.7538 5.50575C10.6484 5.55629 9.57422 5.88885 8.63358 6.47179C7.69293 7.05472 6.91709 7.86864 6.37985 8.8361C5.84262 9.80357 5.56184 10.8924 5.56427 11.999L5.56519 12.016H8.62994L8.62796 12.018ZM15.4172 12.0131H15.4123L19.4836 7.57176L23.5461 12.0151H20.4817C20.4826 13.5301 20.0778 15.0176 19.3093 16.3232C18.5408 17.6287 17.4367 18.7046 16.1117 19.4391C14.7867 20.1736 13.2892 20.5399 11.7748 20.4998C10.2604 20.4598 8.78431 20.0149 7.5 19.2114L8.95929 17.7521C9.94832 18.2742 11.0554 18.5318 12.1733 18.5002C13.2912 18.4686 14.382 18.1487 15.3399 17.5715C16.2978 16.9944 17.0904 16.1796 17.6409 15.2061C18.1913 14.2326 18.4809 13.1335 18.4817 12.0151H15.4152L15.4172 12.0131Z",
    fill: "#27282C",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload-icon.509fa2dd.svg";
export { ForwardRef as ReactComponent };